import React from "react";
import { Flex, Label, Text } from 'src/components';
import { colors } from "src/theme";

interface DescriptionItemProps {
  label: React.ReactNode;
  value?: React.ReactNode;
}

export const DescriptionItem: React.FC<DescriptionItemProps> = ({ label, value }) => {
  const isString = (v: any): v is string => typeof v === 'string';

  return (
    <Flex vertical>
      <Label type='small' color={colors.text4}>{label}</Label>
      {isString(value) ? (
        <Text type='base'>{value}</Text>
      ) : (
        value
      )}
    </Flex>
  )
};

